import React, { Component } from 'react';
import { connect } from 'react-redux';
import './serviceDetail.scss';
import { Table, Modal, Button } from 'antd';
import { fromValidate, history } from '../../../helpers'
import Header from "../../../layout/DefaultLayout/Header";
import BackIcon from "../../../images/arrow.png";
import '../component/login.scss';
import { Link } from "react-router-dom";
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { DatePicker, Space } from 'antd';

class BidRequest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      formError: {},
      formSubmit: false,
      user: {},
      userNumber: '****7890',
      isSuccess: true,
    }
  }

  goBack = () => {
    history.goBack();
  }

  showModalAddress = () => {
		this.setState({
			visibleAddress: true,
		});
	};

	handleOkAddress = e => {
		console.log(e);
		this.setState({
			visibleAddress: false,
		});
	};

	handleCancelAddress = e => {
		console.log(e);
		this.setState({
			visibleAddress: false,
		});
	};

  render() {
    const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
    const { RangePicker } = DatePicker;
    return (
      <div>
        <Header></Header>
        <div className="header-container">
          <img onClick={() => { this.goBack() }} src={BackIcon} className="arrow-icon" alt="" />
          <div className="main-heading-txt">Bid Request</div>
        </div>
        <div className='bid-request-form'>
          <div className="containt-container">
            <div className="form-main-heading-text">Tap And Mixer</div>
            <div className="form-heading-text">Select the issues you are facing</div>
            <form>
              <div className="issues-box">
                <div className="issues-checkbox">
                  <input className="issue-check-box" type="checkbox" name="vehicle1" value="Bike" />
                  <label className="issue-check-lavel" for="vehicle1">Water Saving Nollze</label>
                </div>
                <div className="issues-checkbox">
                  <input className="issue-check-box" type="checkbox" name="vehicle1" value="Bike" />
                  <label className="issue-check-lavel" for="vehicle1">Tap Replacement</label>
                </div>
                <div className="issues-checkbox">
                  <input className="issue-check-box" type="checkbox" name="vehicle1" value="Bike" />
                  <label className="issue-check-lavel" for="vehicle1">Tap Repair</label>
                </div>
                <div className="issues-checkbox">
                  <input className="issue-check-box" type="checkbox" name="vehicle1" value="Bike" />
                  <label className="issue-check-lavel" for="vehicle1">Tap Installation</label>
                </div>
                <div className="issues-checkbox">
                  <input className="issue-check-box" type="checkbox" name="vehicle1" value="Bike" />
                  <label className="issue-check-lavel" for="vehicle1">Hot & cold water mixer Repair</label>
                </div>
                <div className="issues-checkbox">
                  <input className="issue-check-box" type="checkbox" name="vehicle1" value="Bike" />
                  <label className="issue-check-lavel" for="vehicle1">Hot & cold water mixer Installation</label>
                </div>

              </div>

              <div className="row">
                <div className="col-sm-12 col-md-8 col-xs-12">
                  <div className="service-issue-form">
                    <input
                      required
                      id="code"
                      label="Code"
                      type="text"
                      className='form-textfield-containt'
                      variant="outlined"
                      placeholder="Discribe your issue"
                    />

                    <input
                      required
                      id="code"
                      label="Code"
                      type="text"
                      className='form-textfield-containt'
                      variant="outlined"
                      placeholder="Product Name"
                    />
                    <input
                      required
                      id="code"
                      label="Code"
                      type="text"
                      className='form-textfield-containt'
                      variant="outlined"
                      placeholder="Mobile Number"
                    />
                    {/* <DatePicker renderExtraFooter={() => 'extra footer'} showTime /> */}
                    <div className="service-date-heading">When would you like your service?</div>
                    <div className="week-day-box">
                      <div className="week-day-txt active" value="Sun"><div>Sun</div><div>1</div></div>
                      <div className="week-day-txt" value="Mon"><div>Mon</div><div>2</div></div>
                      <div className="week-day-txt" value="Tue"><div>Tue</div><div>3</div></div>
                      <div className="week-day-txt" value="Wed"><div>Wed</div><div>4</div></div>
                      <div className="week-day-txt" value="Thu"><div>Thu</div><div>5</div></div>
                      <div className="week-day-txt" value="Fri"><div>Fri</div><div>6</div></div>
                      <div className="week-day-txt" value="Sat"><div>Sat</div><div>7</div></div>
                    </div>
                    <div className="week-day-box">
                      <div className="week-time-txt"><div>11:00AM</div></div>
                      <div className="week-time-txt active"><div>11:30AM</div></div>
                      <div className="week-time-txt"><div>12:00AM</div></div>
                      <div className="week-time-txt"><div>12:30AM</div></div>
                      <div className="week-time-txt"><div>01:00PM</div></div>
                      <div className="week-time-txt"><div>01:30PM</div></div>
                      <div className="week-time-txt"><div>02:00PM</div></div>
                      <div className="week-time-txt"><div>02:30PM</div></div>
                      <div className="week-time-txt"><div>03:00PM</div></div>
                      <div className="week-time-txt"><div>03:30PM</div></div>
                      <div className="week-time-txt"><div>04:00PM</div></div>
                      <div className="week-time-txt"><div>04:30PM</div></div>
                      <div className="week-time-txt"><div>05:00PM</div></div>
                      <div className="week-time-txt"><div>06:00PM</div></div>
                      <div className="week-time-txt"><div>06:30PM</div></div>
                      <div className="week-time-txt"><div>07:00PM</div></div>
                      <div className="week-time-txt"><div>07:30PM</div></div>
                      <div className="week-time-txt"><div>08:00PM</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-xs-12">
                  <div>
                    <div className="doc-img-box">
                      <div class="upload-btn-wrapper">
                        <img src={EditIcon} className="doc-edit-icon" alt="" />
                        <input type="file" name="myfile" />
                      </div>
                      <img src={NoImage} className="update-prof-img-box" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="form-heading-text">Select Address</div> */}
              <div className="address-top-bar">
                <div className="address-heading-text">Select Address</div>
                <div className="adderee-btx-box" onClick={this.showModalAddress}>
                  <div className="plus-icon">+</div>
                  <div className="new-addr-txt">Add Address</div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-4 col-xs-12">
                  <div className="selected-address-box">
                    <input className="address-redio-btn" type="radio" name="address" value="address" />
                    <label className="address-redio-text" for="address">BEML, Kempegowda Double Road, 5th Stage, RR Nagar, Bengaluru, Karnataka 560098</label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-8 col-xs-12">
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-4 col-xs-12">
                  <div className="selected-address-box">
                    <input className="address-redio-btn" type="radio" name="address" value="address" />
                    <label className="address-redio-text" for="address">BEML, Kempegowda Double Road, 5th Stage, RR Nagar, Bengaluru, Karnataka 560098</label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-8 col-xs-12">
                </div>
              </div>

              <div className="footer-btn">
                <div className="submit-btn">Book Now</div>
              </div>

            </form>
            <Modal
              title="Add Address"
              visible={this.state.visibleAddress}
              onOk={this.handleOkAddress}
              onCancel={this.handleCancelAddress}>
              <div className="">
                <div className="row row-padding">
                  <div className="col-12">
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Address"
                    />
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="City"
                    />
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="State"
                    />
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Country"
                    />
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Zip"
                    />
                  </div>
                </div>
              </div>
            </Modal>

          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(BidRequest);